.wrap { position: relative; max-width: 340px; }
.trigger {
  width: 100%; display: flex; align-items: center; gap: 10px;
  padding: 11px 14px; background: white; border: 1px solid var(--border);
  border-radius: 4px; cursor: pointer; text-align: left;
  font-family: 'Roboto', sans-serif; font-size: 15px; color: var(--ink);
  transition: border-color .15s, box-shadow .15s;
}
.trigger:hover { border-color: #bdc1c6; }
.triggerOpen { border-color: var(--blue); box-shadow: 0 0 0 2px rgba(26,115,232,.15); }
.triggerIcon { color: var(--muted2); flex-shrink: 0; }
.triggerLabel { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.chevron { color: var(--muted2); flex-shrink: 0; transition: transform .2s; }
.chevronOpen { transform: rotate(180deg); }
.dropdown {
  position: absolute; top: calc(100% + 4px); left: 0; right: 0; min-width: 280px;
  background: white; border: 1px solid var(--border); border-radius: 8px;
  box-shadow: var(--shadow-lg); z-index: 200; overflow: hidden; animation: slideIn .15s ease;
}
.searchWrap { position: relative; padding: 10px 10px 8px; border-bottom: 1px solid var(--border); }
.searchIcon { position: absolute; left: 20px; top: 50%; transform: translateY(-50%); color: var(--muted2); pointer-events: none; margin-top: 1px; }
.search {
  width: 100%; padding: 8px 12px 8px 32px; border: 1px solid var(--border);
  border-radius: 6px; font-size: 14px; font-family: 'Roboto', sans-serif;
  color: var(--ink); outline: none; background: var(--bg); transition: border-color .15s, box-shadow .15s;
}
.search:focus { border-color: var(--blue); background: white; box-shadow: 0 0 0 2px rgba(26,115,232,.12); }
.list { list-style: none; max-height: 220px; overflow-y: auto; padding: 4px 0; }
.list::-webkit-scrollbar { width: 6px; }
.list::-webkit-scrollbar-track { background: transparent; }
.list::-webkit-scrollbar-thumb { background: var(--border); border-radius: 3px; }
.option { display: flex; align-items: center; justify-content: space-between; padding: 9px 14px; cursor: pointer; transition: background .1s; }
.optionHighlighted { background: var(--bg); }
.optionSelected { background: var(--blue-lt); }
.optionSelected.optionHighlighted { background: #d8eafd; }
.optionLabel { font-size: 14px; color: var(--ink2); line-height: 1.4; }
.optionSelected .optionLabel { color: var(--blue); font-weight: 500; }
.optionCheck { color: var(--blue); flex-shrink: 0; }
.empty { padding: 16px 14px; font-size: 13.5px; color: var(--muted); text-align: center; }
